RivalIQ.apps.Companies.module('views', function (views, App, Backbone, Marionette, $, _) {

    'use strict';

    views.ChangeFocusCompanyItem = Marionette.ItemView.extend({
        behaviors: {
            MenuItem: {
                behaviorClass: RivalIQ.apps.Shell.behaviors.MenuItem,
                className: 'active'
            }
        },
        tagName: 'li',
        template: '#changeFocusCompanyItemTemplate'
    });

});
